import React, { useCallback, useEffect, useRef } from 'react';
import { useFormContext } from '../FormContext';
import { useUpdateEntityData } from '@sierralabs/entity-ui';
/**
 * EntityDataSource provides a built-in way to save entity data utilizing the
 * form template and entity schema model.
 */
export const EntityDataSource = props => {
    const { disabled, formData, children, onChange, handleUpdate } = props;
    const handleUpdateRef = useRef(handleUpdate);
    handleUpdateRef.current = handleUpdate;
    const onChangeRef = useRef(onChange);
    onChangeRef.current = onChange;
    const { stateMachine, entitySchema, changedFormValue } = useFormContext();
    const previousFormValueRef = useRef(changedFormValue);
    // const [formId, setFormId] = useState<number>();
    const { updatedEntityData, isUpdatingData, updateEntityData } = useUpdateEntityData((entitySchema === null || entitySchema === void 0 ? void 0 : entitySchema.tableName) || '', (formData === null || formData === void 0 ? void 0 : formData.id) || 0);
    const update = useCallback((data) => {
        handleUpdateRef.current
            ? handleUpdateRef.current(data)
            : updateEntityData(data);
    }, [updateEntityData]);
    useEffect(() => {
        var _a;
        if (updatedEntityData) {
            (_a = onChangeRef.current) === null || _a === void 0 ? void 0 : _a.call(onChangeRef, updatedEntityData);
        }
    }, [updatedEntityData]);
    // useEffect(() => {
    //   if (upsertedData?.id || formData?.id) {
    //     setFormId(upsertedData?.id || formData?.id);
    //   }
    // }, [upsertedData, formData]);
    useEffect(() => {
        if (disabled) {
            return;
        }
        if (changedFormValue && previousFormValueRef.current !== changedFormValue) {
            previousFormValueRef.current = changedFormValue;
            const data = entitySchema === null || entitySchema === void 0 ? void 0 : entitySchema.columns.reduce((data, column) => {
                // make sure to only upsert form data of actual entity schema fields
                if (changedFormValue.hasOwnProperty(column.name)) {
                    data[column.name] = changedFormValue[column.name];
                }
                return data;
            }, {});
            update(data);
        }
    }, [changedFormValue, disabled, entitySchema === null || entitySchema === void 0 ? void 0 : entitySchema.columns, update]);
    return React.createElement(React.Fragment, null, children);
};
export default EntityDataSource;
//# sourceMappingURL=EntityDataSource.js.map